import { useCallback, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import researchAnalyticsService, {
  ResearchAnalyticsDetailResponse,
} from '../services/research/researchAnalytics.service';

type ActionType = 'viewed' | 'saved' | 'dismissed' | 'shared';

const useResearchArticleDetail = (newsId: number | null, action: ActionType) => {
  const [page, setPage] = useState(0);
  const [sort, setSort] = useState<string>('actionDate');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc');
  const pageSize = 20;

  useEffect(() => {
    setPage(0);
    setSort('actionDate');
    setSortDir('desc');
  }, [newsId]);

  const { data, isFetching } = useQuery<ResearchAnalyticsDetailResponse>(
    ['researchArticleDetail', newsId, action, sort, sortDir, page],
    () =>
      researchAnalyticsService.articleDetail(newsId!, {
        action,
        sort,
        sortDir,
        page,
        pageSize,
      }),
    {
      enabled: !!newsId,
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );

  const handleSort = useCallback(
    (field: string) => {
      if (sort === field) {
        setSortDir(prev => (prev === 'desc' ? 'asc' : 'desc'));
      } else {
        setSort(field);
        setSortDir('desc');
      }
      setPage(0);
    },
    [sort]
  );

  return {
    data: data?.data || [],
    totalItems: data?.totalItems || 0,
    page,
    pageSize,
    sort,
    sortDir,
    isFetching,
    setPage,
    handleSort,
  };
};

export default useResearchArticleDetail;
